import * as React from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Skeleton from '@mui/material/Skeleton';
import { Button } from '@mui/material';
import { useState, useEffect } from "react";
// import { customToastify} from "../../components/pages/utils/utilsFunctions"
import SearchEskelet from "./SearchEskelet"



const SERVER_URL = `${process.env.REACT_APP_SITEURL}`;



export default function CoverSearchResult(props) {
  const { coverList, handleModalSelectCover } = props
  const [coverLists, setCoverLists] = useState([]);

  useEffect(() => {
    setCoverLists(coverList)
  }, [coverList])
  return (
    <Box sx={{ overflow: 'hidden' }}>
      <Grid container wrap="wrap" sx={{ justifyContent: "center" }}>
        <Box key={0} sx={{ width: 210, mx: 0.5, mt: 1, border: "dashed 1px", borderRadius: "5px" }}>
          <Box sx={{ textAlign: "center" }}>
          </Box>
          <Box sx={{
            width: 210, height: 250,
            backgroundImage: `url("${SERVER_URL}/img/srt/srt.png")`,
            backgroundRepeat: "no-repeat", backgroundSize: "contain", backgroundPosition: "center"
          }} />
          <Button sx={{ m: 1 }} variant="contained" onClick={() => {
            handleModalSelectCover(`${SERVER_URL}/img/srt/srt.png`)
          }}>
            انتخاب
          </Button>
          <Typography sx={{ fontSize: "smaller" }}>
            * تصویر پیش فرض *
          </Typography>
        </Box>
        {coverLists.map((item, index) => (
          <Box key={index + 1} sx={{ width: 210, mx: 0.5, mt: 1, border: "dashed 1px", borderRadius: "5px" }}>
            <Box sx={{ textAlign: "center" }}>
            </Box>
            <Box sx={{
              width: 210, height: 250,
              backgroundImage: `url("${SERVER_URL}/subtitles/covers/${item.fileName}")`,
              backgroundRepeat: "no-repeat", backgroundSize: "contain", backgroundPosition: "center"
            }} />
            <Button sx={{ m: 1 }} variant="contained" onClick={() => {
              handleModalSelectCover(`${SERVER_URL}/subtitles/covers/${item.fileName}`)
            }}>
              انتخاب
            </Button>
          </Box>
        ))}
      </Grid>
    </Box>
  );
}
